// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);
}

.terms-container {
  flex: 1 1;
  max-width: 1000px;
  margin: 0 auto;
  padding: 4rem 2rem;
  width: 100%;
}

.terms-title {
  font-size: 3rem;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 0.5rem;
}

.terms-updated {
  text-align: center;
  font-size: 1rem;
  color: #64748b;
  margin-bottom: 3rem;
}

.terms-content {
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 3rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.terms-intro {
  margin-bottom: 3rem;
}

.terms-intro p {
  font-size: 1.05rem;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 1rem;
}

/* Table of Contents */
.terms-toc {
  background-color: #f8f9fa;
  border-radius: 0.75rem;
  padding: 2rem;
  margin-bottom: 3rem;
  border: 1px solid #e2e8f0;
}

.terms-toc h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.5rem;
}

.terms-toc ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 0.75rem;
}

.terms-toc li {
  margin: 0;
}

.terms-toc a {
  color: #28a745;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.3s ease;
}

.terms-toc a:hover {
  color: #218838;
  text-decoration: underline;
}

/* Terms Sections */
.terms-section {
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e2e8f0;
}

.terms-section:last-of-type {
  border-bottom: none;
}

.terms-section h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.25rem;
  scroll-margin-top: 100px;
}

.terms-section p {
  font-size: 1.05rem;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.terms-section p:last-child {
  margin-bottom: 0;
}

.terms-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.terms-section li {
  font-size: 1.05rem;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 0.75rem;
}

.terms-section li:last-child {
  margin-bottom: 0;
}

.terms-section strong {
  color: #0f172a;
  font-weight: 600;
}

.terms-caps {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
}

/* Footer Note */
.terms-footer-note {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 2px solid #e2e8f0;
  text-align: center;
}

.terms-footer-note p {
  font-size: 1rem;
  color: #64748b;
  margin-bottom: 1rem;
}

.terms-ethical-note {
  font-size: 0.9rem !important;
  color: #94a3b8 !important;
  font-style: italic;
}

.terms-ethical-note a {
  color: #28a745;
  text-decoration: none;
  font-weight: 600;
  font-style: normal;
}

.terms-ethical-note a:hover {
  text-decoration: underline;
}

/* Links */
.terms-section a {
  color: #28a745;
  text-decoration: none;
  font-weight: 500;
}

.terms-section a:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .terms-container {
    padding: 3rem 1.5rem;
  }
  
  .terms-title {
    font-size: 2.25rem;
  }
  
  .terms-content {
    padding: 2rem 1.5rem;
  }
  
  .terms-intro p,
  .terms-section p,
  .terms-section li {
    font-size: 1rem;
  }
  
  .terms-section h2 {
    font-size: 1.35rem;
  }
  
  .terms-toc {
    padding: 1.5rem;
  }
  
  .terms-toc h2 {
    font-size: 1.35rem;
  }
  
  .terms-toc ul {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .terms-container {
    padding: 2rem 1rem;
  }
  
  .terms-title {
    font-size: 2rem;
  }
  
  .terms-content {
    padding: 1.5rem 1rem;
  }
  
  .terms-intro p,
  .terms-section p,
  .terms-section li {
    font-size: 0.95rem;
  }
  
  .terms-section h2 {
    font-size: 1.25rem;
  }
  
  .terms-toc {
    padding: 1.25rem;
  }
  
  .terms-toc h2 {
    font-size: 1.25rem;
  }
  
  .terms-section ul {
    padding-left: 1.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/TermsOfService.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".terms-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);\n}\n\n.terms-container {\n  flex: 1;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 4rem 2rem;\n  width: 100%;\n}\n\n.terms-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n.terms-updated {\n  text-align: center;\n  font-size: 1rem;\n  color: #64748b;\n  margin-bottom: 3rem;\n}\n\n.terms-content {\n  background-color: #ffffff;\n  border-radius: 1rem;\n  padding: 3rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.terms-intro {\n  margin-bottom: 3rem;\n}\n\n.terms-intro p {\n  font-size: 1.05rem;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n/* Table of Contents */\n.terms-toc {\n  background-color: #f8f9fa;\n  border-radius: 0.75rem;\n  padding: 2rem;\n  margin-bottom: 3rem;\n  border: 1px solid #e2e8f0;\n}\n\n.terms-toc h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1.5rem;\n}\n\n.terms-toc ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 0.75rem;\n}\n\n.terms-toc li {\n  margin: 0;\n}\n\n.terms-toc a {\n  color: #28a745;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: color 0.3s ease;\n}\n\n.terms-toc a:hover {\n  color: #218838;\n  text-decoration: underline;\n}\n\n/* Terms Sections */\n.terms-section {\n  margin-bottom: 3rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.terms-section:last-of-type {\n  border-bottom: none;\n}\n\n.terms-section h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1.25rem;\n  scroll-margin-top: 100px;\n}\n\n.terms-section p {\n  font-size: 1.05rem;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.terms-section p:last-child {\n  margin-bottom: 0;\n}\n\n.terms-section ul {\n  margin: 1rem 0;\n  padding-left: 2rem;\n}\n\n.terms-section li {\n  font-size: 1.05rem;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 0.75rem;\n}\n\n.terms-section li:last-child {\n  margin-bottom: 0;\n}\n\n.terms-section strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.terms-caps {\n  font-size: 0.95rem !important;\n  font-weight: 500 !important;\n  letter-spacing: 0.3px;\n}\n\n/* Footer Note */\n.terms-footer-note {\n  margin-top: 3rem;\n  padding-top: 2rem;\n  border-top: 2px solid #e2e8f0;\n  text-align: center;\n}\n\n.terms-footer-note p {\n  font-size: 1rem;\n  color: #64748b;\n  margin-bottom: 1rem;\n}\n\n.terms-ethical-note {\n  font-size: 0.9rem !important;\n  color: #94a3b8 !important;\n  font-style: italic;\n}\n\n.terms-ethical-note a {\n  color: #28a745;\n  text-decoration: none;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.terms-ethical-note a:hover {\n  text-decoration: underline;\n}\n\n/* Links */\n.terms-section a {\n  color: #28a745;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.terms-section a:hover {\n  text-decoration: underline;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .terms-container {\n    padding: 3rem 1.5rem;\n  }\n  \n  .terms-title {\n    font-size: 2.25rem;\n  }\n  \n  .terms-content {\n    padding: 2rem 1.5rem;\n  }\n  \n  .terms-intro p,\n  .terms-section p,\n  .terms-section li {\n    font-size: 1rem;\n  }\n  \n  .terms-section h2 {\n    font-size: 1.35rem;\n  }\n  \n  .terms-toc {\n    padding: 1.5rem;\n  }\n  \n  .terms-toc h2 {\n    font-size: 1.35rem;\n  }\n  \n  .terms-toc ul {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .terms-container {\n    padding: 2rem 1rem;\n  }\n  \n  .terms-title {\n    font-size: 2rem;\n  }\n  \n  .terms-content {\n    padding: 1.5rem 1rem;\n  }\n  \n  .terms-intro p,\n  .terms-section p,\n  .terms-section li {\n    font-size: 0.95rem;\n  }\n  \n  .terms-section h2 {\n    font-size: 1.25rem;\n  }\n  \n  .terms-toc {\n    padding: 1.25rem;\n  }\n  \n  .terms-toc h2 {\n    font-size: 1.25rem;\n  }\n  \n  .terms-section ul {\n    padding-left: 1.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
